<template>
<!-- v-if="paging.total" -->
    <el-pagination
        class="paging"
        @prev-click="prevClick"
        @next-click="nextClick"
        @current-change="currentChange"
        @size-change="handleSizeChange"
        background
        :current-page.sync="paging.params.pageNum"
        :page-size="paging.params.pageSize"
        :layout="layout"
        :total="paging.total"
        :page-sizes="[10, 20, 30, 40]"
    >
    </el-pagination>
</template>

<script>
export default {
  name: 'dyPaging',
  props: {
    paging: Object,
    layout:{
      type: String,
      default: 'total, prev, pager, next,sizes',
    }
    // layout: 'total, sizes, prev, pager, next, jumper',
  },
  data () {
    return {
      pagingConfig: {
        params: {
          pageNum: 1,
          pageSize: 10
        },
        total: 0
      }
    }
  },
  mounted () {},
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.paging.params.pageSize = val
      this.getParent(this.$parent, 'getDataList');
    },
    currentChange (val) {
      console.log(` 第${val}页 `);
      this.paging.params.pageNum = val
      this.getParent(this.$parent, 'getDataList');
    },
    getParent (parent, fn) {
      console.log('=====>parent函数', parent, fn)
      if (parent[fn]) {
        // console.log('=====>parent函数', parent[fn])
        parent[fn]()
      } else {
        console.log('--->走了else')
        this.getParent(parent.$parent, fn)
      }
    },
    prevClick (val) {
      this.currentChange(val);
    },
    nextClick (val) {
      this.currentChange(val);
    }
  }
}

</script>

<style scoped lang="stylus">
  .paging {
    text-align: center;
    margin-top: 20px;
    color: $mainColor;
    /deep/ .el-input__inner {
      height: 32px !important;
    }
    
    /deep/.el-pagination__total,/deep/.el-pagination__sizes {
      color: $mainColor;
      font-size:14px;
      line-height:32px;
      height 32px
      margin-right 30px
    }
    /deep/.el-pagination__jump {
      margin-left 22px
      .el-pagination__editor.el-input {
        width 32px
        height 32px
        margin 0 5px
        padding 0
      }
      
      .el-input__inner {
        width 32px
        padding 0
      }
    }
  
   
  }
</style>
